import { KisweSize } from './../types'

interface DefaultPropValues {
  size: KisweSize
}

const useSizes = (defaults?: Partial<DefaultPropValues>) => {
  const props = {
    size: {
      type: String,
      required: false,
      default: defaults?.size ?? KisweSize.Medium,
      validator: (value: KisweSize) => Object.values(KisweSize).includes(value)
    }
  }

  return {
    props
  }
}

export default useSizes
